import api from "../api";
import moment from "moment";
import {
  COMMENT_LIST_REQUEST,
  COMMENT_LIST_SUCCESS,
  COMMENT_LIST_FAILURE,
  COMMENT_CREATE_REQUEST,
  COMMENT_CREATE_SUCCESS,
  COMMENT_CREATE_FAILURE,
} from "./types";
import { timeToStale } from "../constants";
import { notificationDisplay } from "./notificationActions";

const DEFAULT_ERROR = "Comments endpoint error.";

// ---------------- LIST COMMENTS ----------------
const commentListRequest = () => ({
  type: COMMENT_LIST_REQUEST,
});

const commentListSuccess = (comments) => ({
  type: COMMENT_LIST_SUCCESS,
  comments,
});

const commentListFailure = (error) => ({
  type: COMMENT_LIST_FAILURE,
  error,
});

export const commentList = (projectId) => async (dispatch, getState) => {
  // check cache
  const cachedAt = getState().comments.cachedAt;
  if (moment().diff(cachedAt, "m") < timeToStale) return;
  // cache got stale
  dispatch(commentListRequest());
  let resp, status, detail;
  try {
    resp = await api.recorder.comment.list(projectId);
    status = resp.status;
  } catch (error) {
    console.log(COMMENT_LIST_FAILURE, error);
    dispatch(commentListFailure(DEFAULT_ERROR));
  }
  switch (status) {
    case 200: {
      const comments = await resp.json();
      dispatch(commentListSuccess(comments));
      break;
    }
    case 400:
    case 403:
      detail = resp.json().detail;
      dispatch(commentListFailure(detail));
      dispatch(notificationDisplay("error", [detail]));
      break;
    case 422:
      detail = resp.json().detail;
      dispatch(commentListFailure(detail));
      dispatch(
        notificationDisplay(
          "error",
          detail.map((d) => `${d.loc[d.loc.length - 1]}: ${d.msg}`)
        )
      );
      break;
    default:
      console.log(COMMENT_LIST_FAILURE, status);
      dispatch(commentListFailure(DEFAULT_ERROR));
      break;
  }
};

// ---------------- CREATE COMMENT ----------------
const commentCreateRequest = () => ({
  type: COMMENT_CREATE_REQUEST,
});

const commentCreateSuccess = (comment) => ({
  type: COMMENT_CREATE_SUCCESS,
  comment,
});

const commentCreateFailure = (error) => ({
  type: COMMENT_CREATE_FAILURE,
  error,
});

export const commentCreate = (recordingId, text) => async (dispatch) => {
  dispatch(commentCreateRequest());
  let resp, status, detail;
  try {
    resp = await api.recorder.comment.create(recordingId, text);
    status = resp.status;
  } catch (error) {
    console.log(COMMENT_CREATE_FAILURE, error);
    dispatch(commentCreateFailure(DEFAULT_ERROR));
  }
  switch (status) {
    case 200: {
      const comment = await resp.json();
      dispatch(commentCreateSuccess(comment));
      break;
    }
    case 403:
      detail = resp.json().detail;
      dispatch(commentCreateFailure(detail));
      dispatch(notificationDisplay("error", [detail]));
      break;
    case 422:
      detail = resp.json().detail;
      dispatch(commentCreateFailure(detail));
      dispatch(
        notificationDisplay(
          "error",
          detail.map((d) => `${d.loc[d.loc.length - 1]}: ${d.msg}`)
        )
      );
      break;
    default:
      console.log(COMMENT_CREATE_FAILURE, status);
      dispatch(commentCreateFailure(DEFAULT_ERROR));
      break;
  }
};
